import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FolderId } from 'modules/domains/foldering';

import { getTemplatePreviewThumbnailsRequest } from '../ducks/actions';
import { selectPreviewThumbnails } from '../ducks/selectors';

export type PreviewThumbnailsById = Record<number, string>;

/**
 * Dispatches a network request to retrieve the preview urls for templates based on ID. Returns the Redux store entry
 * @param templateIds - a list of template ids that need preview URLs
 * @returns hash of preview urls keyed by template id
 */
export const usePreviewThumbnails = (templateIds: FolderId[]): PreviewThumbnailsById => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (templateIds) {
      // expects ids as number
      const safeIds = templateIds.map((tmpId) => {
        if (typeof tmpId === 'string') {
          return parseInt(tmpId, 10);
        }
        return tmpId;
      });
      dispatch(getTemplatePreviewThumbnailsRequest(safeIds));
    }
  }, [templateIds.join('-')]); // React has a hard time avoiding render thrash on arrays

  return useSelector(selectPreviewThumbnails);
};
